import axios from 'axios'
import Utils from '../services/Utils'

export default {
    getAuthorization: function () {
        const user = JSON.parse(process.env.VUE_APP_EMAIL).storage
        const password = JSON.parse(process.env.VUE_APP_PASSWORD).storage
        return 'Basic ' + window.btoa(user + ':' + password)
    },
    getFile(data, callback) {
        axios.get(axios.defaults.storageApiUrl + 'file?filter={"id":' + data.id + '}&lng=' + window.language, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: this.getAuthorization(),
            },
        }).then((response) => {
            Utils.processResponse(response, callback)
        }).catch((response) => {
            Utils.processResponse(response, callback)
        })
    },
    sendFile(data, callback) {
        axios.post(axios.defaults.storageApiUrl + 'file?base64=true' + (data.compressed ? '&compressed=1' : '') + '&lng=' + window.language,
            data.file, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: this.getAuthorization(),
            },
        }).then((response) => {
            Utils.processResponse(response, callback)
        }).catch((response) => {
            Utils.processResponse(response, callback)
        })
    },
    deleteFile(id, callback) {
        axios.delete(axios.defaults.storageApiUrl + 'file?id=' + id + '&lng=' + window.language, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: this.getAuthorization(),
            },
        }).then((response) => {
            Utils.processResponse(response, callback)
        }).catch((response) => {
            Utils.processResponse(response, callback)
        })
    },
    convertImageHeicToPng(file, callback) {
        const formData = new FormData()
        formData.append('file', file)
        axios.post(axios.defaults.storageApiUrl + 'file/convert/heic?lng=' + window.language,
            formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
                'X-Data-Type': 'image/heic',
                Authorization: this.getAuthorization(),
            },
        }).then((response) => {
            Utils.processResponse(response, callback)
        }).catch((response) => {
            Utils.processResponse(response, callback)
        })
    },
    sendVideo(data, callback) {
        const self = this
        if (data.fileToUpdate) {
            send(data.fileToUpdate)
        } else {
            get()
        }

        function get() {
            axios.get(axios.defaults.storageApiUrl + 'file', {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: self.getAuthorization(),
                },
                params: {
                    filter: {
                        name: data.file.name
                    },
                    lng: window.language
                }
            }).then((response) => {
                Utils.processResponse(response, send)
            }).catch((response) => {
                Utils.processResponse(response, send)
            })
        }

        function send(files) {
            const params = {
                lng: window.language
            }
            if (data.base64) {
                params.base64 = true
            }
            if (data.compressed) {
                params.compressed = 1
            }
            if (data.totalChunks || data.totalChunks === 0) {
                params.chunks = data.totalChunks
            }
            if (data.chunkIndex || data.chunkIndex === 0) {
                params.chunk_idx = data.chunkIndex
            }
            if (files && files.data && files.data[0] && files.data[0].id) {
                params.id = files.data[0].id
                axios.patch(axios.defaults.storageApiUrl + 'file',
                    data.file, {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: self.getAuthorization(),
                    },
                    params: params
                }).then((response) => {
                    Utils.processResponse(response, callback, files)
                }).catch((response) => {
                    Utils.processResponse(response, callback)
                })
            } else {
                axios.post(axios.defaults.storageApiUrl + 'file',
                    data.file, {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: self.getAuthorization(),
                    },
                    params: params
                }).then((response) => {
                    Utils.processResponse(response, callback, files)
                }).catch((response) => {
                    Utils.processResponse(response, callback)
                })
            }
        }
    },
    uploadFile(data, callback) {
        const aws = JSON.parse(process.env.VUE_APP_AWS)
        axios.post(aws.url,
            {
                fileName: data.name,
                fileType: data.type,
            }, {
            headers: {
                'Content-Type': 'application/json',
                'X-Api-Key': aws.key,
            },
        }).then(async(response) => {
            if (response.data && response.data.upload_url) {
                try {
                    await fetch(response.data.upload_url, {
                        method: 'PUT',
                        headers: {
                            'Content-Type': data.type,
                            'X-Amz-Acl' : 'bucket-owner-full-control'
                        },
                        body: data,
                    })
                    callback({
                        success: true,
                        data: response.data
                    })
                } catch {
                    callback({
                        success: false
                    })
                }
            } else {
                callback({
                    success: false,
                })
            }
        }).catch((response) => {
            Utils.processResponse(response, callback)
        })
    }
}
